const BookingFailed = () => {
  return (
    <div className="d-flex justify-content-center mt-5 text-center">
      <section>
        <h1>Booking Failed</h1>
        <br />
        <p className="fs-5">
          Appointment booking failed due to the problem in the system. Try Again Later. 
        </p>
        <div>
        </div>
      </section>
    </div>
  );
};

export default BookingFailed;
